import { Fancybox } from '@fancyapps/ui/';

Fancybox.bind('[data-fancybox-assembly-video]', {
	// Custom options for all galleries

	defaultType: "youtube",
});

export function initializeBlock(originalBlock) {
	/*
  jQuery( '.variations_form' ).on( 'woocommerce_variation_select_change', function() {
    const figures: NodeListOf<HTMLElement> = originalBlock.querySelectorAll('.wp-block-site-product-documents__docs');

    for(var i = 0; i < figures.length; i++){
      figures[i].style.display = "none";
    }
  });

  jQuery( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
    const variation_id = variation.variation_id;

    const figure: HTMLElement|null = originalBlock.querySelector(`.wp-block-site-product-documents__docs.product-${variation_id}`);
    if (figure) {
      figure.style.display = "block";
    }
  });
	*/
}
